export default __webpack_public_path__ + "static/media/oatmealcookies.36dad236.jpg";